import styled, { keyframes } from "styled-components";
import { paletas } from "../../../../../styles/theme";

const modalAnima = keyframes`
  from {
    opacity: 0.5;
  }

  50% {
    transform: scale(1.5);
  }

  to {
    opacity: 1;
  }
`;

const selecaoAnima = keyframes`
  50% {
    transform: scale(1.05);
  }
`;

export const Wrapper = styled.section`
  position: relative;
  height: 100%;

  h3,
  h4,
  p,
  span {
    font-size: 1rem;
    font-weight: 500;
    font-family: "Bebas Neue", cursive;
    font-family: "Open Sans", sans-serif;
    font-family: "Poppins", sans-serif;
  }

  .headerInterno {
    margin: 0 auto;
    text-align: center;
    max-width: 600px;

    &.blur {
      filter: blur(4px);
      pointer-events: none;
    }

    h3 {
      margin-bottom: 20px;
      line-height: 2rem;
    }

    h4 {
      text-align: left;
      margin: 20px 0 10px;
    }

    button {
      font-size: 16px;
    }
  }
  .botaoIniciar {
    margin: 40px auto;

    &.blur {
      filter: blur(4px);
      pointer-events: none;
    }
  }

  .botoes {
    button {
      width: 100%;
      font-size: 20px;
      color: ${paletas.White};
      border: none;
      border-radius: 0.25rem;
      padding: 10px 0;
      transition: all 0.25s;
      text-transform: uppercase;
      background: ${paletas.Grafite75};

      @media (max-width: 420px) {
        font-size: 16px;
      }

      @media (max-width: 320px) {
        font-size: 14px;
      }
    }
  }

  .ativo {
    button {
      background-color: ${paletas.DarkOrange};
      animation: 0.25s ${selecaoAnima};
    }
  }

  .disabled {
    opacity: 0.1;
  }
`;

export const Popup = styled.div`
  text-align: center;
  width: 100%;
  max-width: 260px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  padding: 20px;
  background: ${paletas.Grafite75};
  border-radius: 0.25rem;
  animation: 0.5s ${modalAnima};
  z-index: 2;
  font-size: 20px;
  font-style: normal;
  font-weight: normal;

  @media (min-width: 640px) {
    max-width: 600px;
    margin: 40px auto auto;
  }

  a {
    color: ${paletas.White};

    &:hover {
      color: ${paletas.RedTheme};
    }
  }

  h4 {
    margin: 20px 0;
  }

  h5 {
    font-size: 18px;
    margin: 10px 0 20px;
    font-weight: normal;
  }

  button {
    width: 100%;
    color: ${paletas.White};
    border: none;
    border-radius: 0.25rem;
    padding: 5px 0;
    text-transform: uppercase;
    font-size: 20px;
    max-width: 250px;
    background: ${paletas.DarkPurple};
    transition: all 0.25s;
  }
`;
